import { render, staticRenderFns } from "./human-resource-item.vue?vue&type=template&id=3f686795&scoped=true"
import script from "./human-resource-item.vue?vue&type=script&lang=js"
export * from "./human-resource-item.vue?vue&type=script&lang=js"
import style0 from "./human-resource-item.vue?vue&type=style&index=0&id=3f686795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f686795",
  null
  
)

export default component.exports